 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		9: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		9: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"96a75f88365e04c35058c6e31825ac6209c5cdd6","2":"1ff30e0e5e69ed53a04c305a35f7e4cb20db1577","3":"c053e44d2e6345d4ca390ffe8f30a5004bbb0f8a","4":"530ef704bdcb0805d89a7b113c0be09ef5d468dd","5":"d8ad0d8d1c9715afe9e72c8952819119fcff334d","6":"ea135cc274a5417bd09e177554c2c4ce9410a044","7":"a11d0a966936ff5c6ac266d429fab19a2257d3f5","8":"b3d8560322c644f6b4d530b2fc562859fc4c88d6","10":"94726e6d","12":"component---src-components-blog-blog-detail-js","13":"component---src-components-blog-blog-list-js","14":"component---src-components-projects-completed-template-js","15":"component---src-components-projects-ongoing-template-js","16":"component---src-pages-404-js","17":"component---src-pages-about-js","18":"component---src-pages-campaign-index-js","19":"component---src-pages-campaign-plutus-js","20":"component---src-pages-campaign-plutus-thank-you-js","21":"component---src-pages-commercial-completed-projects-js","22":"component---src-pages-commercial-ongoing-projects-js","23":"component---src-pages-completed-projects-js","24":"component---src-pages-contact-js","25":"component---src-pages-crown-residence-js","26":"component---src-pages-gallery-js","27":"component---src-pages-index-js","28":"component---src-pages-joint-venture-js","29":"component---src-pages-media-js","30":"component---src-pages-ongoing-projects-js","31":"component---src-pages-privacy-policy-js","32":"component---src-pages-project-status-js","33":"component---src-pages-promenade-js","34":"component---src-pages-royal-damera-gardens-js","35":"component---src-pages-terms-js","36":"component---src-pages-the-peak-js","37":"component---src-pages-walkthrough-crown-index-js","38":"component---src-pages-willow-square-js"}[chunkId]||chunkId) + "-" + {"0":"0ec71dd62c66cb95665c","1":"daaf252ff5cefb8b65b6","2":"dcfbc30963a621fec7f3","3":"58d773d7c958b905b4b9","4":"fae426d95ba6f8b64593","5":"337cf32752b436e7a08f","6":"5ec662d63dcbc7bfd210","7":"bd9447b006b9d160beb8","8":"eff42e26afe81514d2a5","10":"b274fe195665da36332d","12":"900d2496e2cbfe26d9bd","13":"38fad0acdd606c3d07e6","14":"f87a2caa5f2c6b509328","15":"61b4ce4b96894e33f2d5","16":"8785e822eae6f20eaacd","17":"7167b6d1a02458de806b","18":"789d0b4f5f9b7fa15ddf","19":"b4a299e48f9346233f03","20":"a98b7f99242c6865caeb","21":"2a98abf4358ded46e978","22":"a3fa3afdd7ea2a2bd4b1","23":"0e66ced6ff3eacbdcd0c","24":"85ef996096646680c334","25":"0cf5ab1b78e12022b403","26":"80f02e3422bbddce7cc0","27":"61cdf2c026a5156f14ec","28":"8e57b0d9c76185ca92c2","29":"3dbc9b4bbda70b933359","30":"b90009119ace845f50ab","31":"f754444654a4a3059a73","32":"7e8916788faf0ca70af7","33":"bab2b977d4bbe0895ced","34":"7c6516cfa2596079e2ae","35":"46a1761ce4abc3cff4f2","36":"adaec559d92d25dc3c2e","37":"1f58abf5f1ab5d984e94","38":"bca2e2313a7fe45e687c","41":"eeb9be5ee83b5bbbcad1"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"96a75f88365e04c35058c6e31825ac6209c5cdd6","2":"1ff30e0e5e69ed53a04c305a35f7e4cb20db1577","3":"c053e44d2e6345d4ca390ffe8f30a5004bbb0f8a","4":"530ef704bdcb0805d89a7b113c0be09ef5d468dd","5":"d8ad0d8d1c9715afe9e72c8952819119fcff334d","6":"ea135cc274a5417bd09e177554c2c4ce9410a044","7":"a11d0a966936ff5c6ac266d429fab19a2257d3f5","8":"b3d8560322c644f6b4d530b2fc562859fc4c88d6","10":"94726e6d","12":"component---src-components-blog-blog-detail-js","13":"component---src-components-blog-blog-list-js","14":"component---src-components-projects-completed-template-js","15":"component---src-components-projects-ongoing-template-js","16":"component---src-pages-404-js","17":"component---src-pages-about-js","18":"component---src-pages-campaign-index-js","19":"component---src-pages-campaign-plutus-js","20":"component---src-pages-campaign-plutus-thank-you-js","21":"component---src-pages-commercial-completed-projects-js","22":"component---src-pages-commercial-ongoing-projects-js","23":"component---src-pages-completed-projects-js","24":"component---src-pages-contact-js","25":"component---src-pages-crown-residence-js","26":"component---src-pages-gallery-js","27":"component---src-pages-index-js","28":"component---src-pages-joint-venture-js","29":"component---src-pages-media-js","30":"component---src-pages-ongoing-projects-js","31":"component---src-pages-privacy-policy-js","32":"component---src-pages-project-status-js","33":"component---src-pages-promenade-js","34":"component---src-pages-royal-damera-gardens-js","35":"component---src-pages-terms-js","36":"component---src-pages-the-peak-js","37":"component---src-pages-walkthrough-crown-index-js","38":"component---src-pages-willow-square-js"}[chunkId]||chunkId) + "." + {"0":"44f8bc1a3732b1844419","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
